export const LOAD_FRAUD_CUSTOMERS = "LOAD_FRAUD_CUSTOMERS";
export const UPDATE_FRAUD_CUSTOMERS = "UPDATE_FRAUD_CUSTOMERS";
export const UPLOAD_SUMMARY = "UPLOAD_SUMMARY";
export const RESET_UPLOAD_SUMMARY = "RESET_UPLOAD_SUMMARY";
